import { Longhand } from "../longhand.js";
import Base from "./border-top-left-radius.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-start-start-radius}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=border-start-start-radius.js.map